module.exports = __webpack_public_path__ + "img/user_mng.14a3f583.svg";